import { getGlobalSingleton } from '@sentry/utils';
import { Scope } from './scope.js';
/** Get the default current scope. */

function getDefaultCurrentScope() {
  return getGlobalSingleton('defaultCurrentScope', function () {
    return new Scope();
  });
}
/** Get the default isolation scope. */


function getDefaultIsolationScope() {
  return getGlobalSingleton('defaultIsolationScope', function () {
    return new Scope();
  });
}

export { getDefaultCurrentScope, getDefaultIsolationScope };